import { render, staticRenderFns } from "./AddOrDetail.vue?vue&type=template&id=8bccba90&scoped=true&"
import script from "./AddOrDetail.vue?vue&type=script&lang=js&"
export * from "./AddOrDetail.vue?vue&type=script&lang=js&"
import style0 from "./AddOrDetail.vue?vue&type=style&index=0&id=8bccba90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bccba90",
  null
  
)

export default component.exports